<template>
  <b-modal 
    v-model="isVisible" 
    size="xl" 
    hide-footer
    @hidden="onHidden"
  >
    <h3 class="modal-title">Informe de la Imagen</h3>

    <b-card 
      v-if="dataImagen"
      bg-variant="light" 
      text-variant="black"
      class="mt-1"
    >
      <b-row>
        <b-col>
          <b>Paciente: </b>{{ dataImagen.paciente }}
        </b-col>

        <b-col>
          <b>Tipo Imagen: </b>{{ dataImagen.tipoImagen }}
        </b-col>
      </b-row>
    </b-card>

    <b-tabs content-class="mt-3">

      <b-tab title="Redaccion" v-if="showTabRedaccion()" active >
        <b-card style="border: 1px solid #c9c9c9">

          <b-row class="my-1">
            <b-col cols="6">
              <label>Informe: </label>

              <b-form-textarea 
                v-model="informe" 
                class="form-control"
                rows="20"
                required
              />

            </b-col>

            <b-col  cols="6">

              <div class="mb-2">
                <label for="conclusion">Conclusion: </label>
                <b-form-textarea 
                  id="conclusion" 
                  v-model="conclusion" 
                  class="form-control" 
                  required 
                  rows="4"
                />
              </div>


              <div class="mb-2">
                <label for="imagenologo">Quien realizó el proceso? </label>
                <v-select 
                  id="imagenologo" 
                  v-model="imagenologo" 
                  :options="imagenologosOpts"
                  :reduce="option => option.value" 
                  label="text" 
                  class="d-inline-block w-100" 
                  required 
                />
              </div>


              <div>
                <label for="diagnostico">Diagnosticos de la Imagenología:</label>

                <div class="row d-flex align-items-center mb-2">
                  <SearchOpts
                    class="col-10"
                    v-model="searchDiagnosticos.selected"
                    :searchService="onSearchDiagnosticos"
                    :placeholder="'Buscar diagnosticos...'"
                    :minChars="2"
                  />

                  <b-button 
                    variant="info" 
                    size="sm" 
                    @click="agregarDiagnostico()" 
                    style="cursor: pointer;"
                    :disabled="searchDiagnosticos.selected === null"
                  >
                    <strong>
                      <i 
                        class="fas fa-solid fa-plus" 
                        title="Agregar Diagnóstico" 
                      />
                    </strong>
                  </b-button>
                </div>

                

                <b-table 
                  :items="diagnosticosList" 
                  :fields="fieldsti"
                  v-if="diagnosticosList.length"
                >
                  <template #cell(diagnostico)="data">
                    {{ data.item.diagnosticotext }}
                  </template>

                  <template #cell(acciones)="data">
                    <b-button 
                      variant="danger" 
                      size="sm" 
                      @click="removeDiagnostico(data.index)" 
                      style="cursor: pointer;"
                    >
                      <font-awesome-icon icon="circle-xmark" />
                    </b-button>
                  </template>
                </b-table>
              </div>
              
            </b-col>
          </b-row >

        </b-card>
      </b-tab>


      <b-tab 
        v-if="showTabSubirMsp()" 
        title="Subir MSP" 
        :title-item-class="{ 'd-none': !showTabSubirMsp() }"
      >
        <b-col cols="12">
          <!-- <MspsPaciente :paciente = "dataImagen.pacient" />
          <MspsPaciente :paciente = "dataImagen.pacient" /> -->
        </b-col>

        <ProcesarImagenLoadMsp
          v-if="idPaciente"
          :idPaciente="idPaciente"
          :idCita="idCita"
          :dataInforme="dataInforme"
        />
      </b-tab>

      <b-tab title="Subir Imagenes" v-if="showTabSubirImagenes()">
        <b-card>
          <LoadFileInput
            v-model="archivoImagenes"
            label="imagenes"
            :urlFile="urlCarpetaImagenes"
          />
        </b-card> 
        <b-card>
          <LoadFileInput
            v-model="archivoImagenDicom"
            label="Imagen Dicom"
            :urlFile="urlCarpetaImagenesDicom"
            :tokenImagen="tokenImagen"
          />
        </b-card> 
      </b-tab>

    </b-tabs>

    <div class="d-flex justify-content-end mb-2">
      <b-button 
        variant="secondary" 
        @click="onHidden" 
        class="mr-2"
      >
        Cancelar
      </b-button>

      <b-button variant="primary" @click="ejecutarInformeImagen">
        Realizar Informe
      </b-button>
    </div>
    
  </b-modal>
</template>



<script>

import vSelect from 'vue-select';
import { fileService } from "@/shared/services";
import { diagnosticosService } from '@/views/atencionMedica/services';
import { addUniqueNewOpt, comprobarRoles } from '@/shared/helpers';
import { ROLES } from '@/shared/constants';
import { mapState } from 'vuex';
import { LoadFileInput, SearchOpts } from '@/shared/components';
import { imagenologosService, imagenesService } from "@/views/imagen/services";
import ProcesarImagenLoadMsp from './ProcesarImagenLoadMsp.vue';

export default {
  name: 'ModalProcesarImagen',

  components: {
    vSelect,
    ProcesarImagenLoadMsp,
    LoadFileInput,
    SearchOpts
  },



  async created() {
    this.imagenologosOpts = await imagenologosService.getImagenologosSelect();
    this.loadData();
  },

  data() {
    return {

      isVisible: false,
      idCita:null,
      tokenImagen: null,
      dataImagen: null,

      dataInforme: null,
      urlCarpetaImagenes: null,
      urlCarpetaImagenesDicom: null,
      idPaciente: null,

      urlInforme: null,
      doctorEspecialidad: null,

      informe: null,
      conclusion: '',
      imagenologo: null,
      requiresMsp: true,

      searchDiagnosticos: {
        query: '',
        isLoading: false,
        searchFailed: false,
        selected: null
      },


      imagenologosOpts: [],
      diagnosticosOpts: [],

      archivoInformeMedico: null,
      archivoMsp: null,
      archivoImagenes: null,
      archivoImagenDicom: null,
      diagnosticosList: [],
      fieldsti: [
        { 
          key: 'diagnostico', 
          label: 'Descripcion', 
          thClass: 'text-center' 
        },
        { 
          key: 'acciones', 
          label: 'acciones', 
          sortable: true, 
          thClass: 'text-center', 
          tdClass: 'text-right' 
        },
      ],
    }
  },

  methods: {

    async loadData(){
      const tokenImagen = this.$route.query.procesar;
      if (!tokenImagen) return;

      this.tokenImagen = tokenImagen;
      const responseImagen = await imagenesService.getByToken(this.tokenImagen);

      if(!responseImagen){
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Error al cargar informacion de imagen.'
        });
        return;
      }

      const dataPaciente = responseImagen.consultamedica.cita.paciente.persona;

      this.dataImagen = {
        paciente       : `${dataPaciente.primerApellido} ${dataPaciente.primerNombre}`,
        tipoImagen     : responseImagen.imagen.nombre,
        idImagenEnviada: responseImagen.id
      };
      this.idCita = responseImagen.consultamedica.cita.id;
      this.idPaciente = responseImagen.consultamedica.cita.paciente.id;
      const especialidadDoctor = responseImagen.consultamedica?.cita?.doctor?.especialidad?.descripcion || '';
      const codigoEspecialidad = responseImagen.consultamedica?.cita?.doctor?.especialidad?.codEsp
        || responseImagen.consultamedica?.cita?.doctor?.especialidad?.codigo
        || responseImagen.consultamedica?.cita?.doctor?.especialidad?.id;
      const codigoEspecialidadAlterno = responseImagen.consultamedica?.cita?.doctor?.especialidadId
        || responseImagen.consultamedica?.cita?.doctor?.idEspecialidad;
      this.doctorEspecialidad = especialidadDoctor;
      const isOdontologiaCE = this.isEspecialidadOdontologiaCe(
        especialidadDoctor,
        codigoEspecialidad,
        codigoEspecialidadAlterno
      );
      this.requiresMsp = !isOdontologiaCE;
      if (!this.requiresMsp) {
        this.$store.commit('resetFiles');
      }

      const informesActivos = responseImagen.informes.filter(i => i.estado === '1');

      console.log("informesActivos", informesActivos);

      const responseInforme = informesActivos[0];
      
      if(responseInforme){
        this.dataInforme = responseInforme;
        this.urlCarpetaImagenes       = responseInforme.urlCarpetaImagenes;
        this.urlCarpetaImagenesDicom  = responseInforme.urlCarpetaImagenesDicom;

        this.informe     = responseInforme.informeImagen;
        this.conclusion  = responseInforme.conclusionImagen;
        this.imagenologo = responseInforme.imagenologo?.id;


        const dataDiagnosticos = responseInforme.diagimageninformeSet;
        
        const diagnosticosFiltrados = dataDiagnosticos.filter(diagnostico => diagnostico.estado === "1");
        this.diagnosticosList = diagnosticosFiltrados.map(diagnostico => ({
          idDiagAnam: diagnostico.id,
          diagnostico: diagnostico.diagnostico.id,
          diagnosticotext : `(${diagnostico.diagnostico.codigo}) ${diagnostico.diagnostico.descripcion}`,
          estado: diagnostico.estado
        }));
          
      } 

      this.isVisible = true;
    },


    async onSearchDiagnosticos(search) {
      const responseSearch = await diagnosticosService.getByQuerySelect(search);
      return responseSearch;
    },


    showTabRedaccion(){
      const hasPermission = comprobarRoles([ROLES.IMAGENES, ROLES.AUX_IMAGENES, ROLES.JEFE_MEDICO]);
      return hasPermission
    },

    showTabSubirMsp(){
      const hasPermission = comprobarRoles([ROLES.AUX_IMAGENES, ROLES.JEFE_MEDICO, ROLES.AGENDAMIENTO, ROLES.ADMISION]);
      return hasPermission && this.requiresMsp;
    },

    showTabSubirImagenes(){
      const hasPermission = comprobarRoles([ROLES.IMAGENES, ROLES.AGENDAMIENTO, ROLES.AUX_IMAGENES, ROLES.JEFE_MEDICO]);
      return hasPermission
    },

    onAddUniqueNewOpt(newArray) {
      return addUniqueNewOpt(newArray);
    },

    isEspecialidadOdontologiaCe(descripcion, codigo = null, codigoAlterno = null) {
      const allowedCodes = ['2', '0000000134'];
      const formattedCode = (codigo !== null && codigo !== undefined)
        ? String(codigo).trim()
        : '';

      if (formattedCode && allowedCodes.includes(formattedCode)) {
        return true;
      }

      const formattedAltCode = (codigoAlterno !== null && codigoAlterno !== undefined)
        ? String(codigoAlterno).trim()
        : '';

      if (formattedAltCode && allowedCodes.includes(formattedAltCode)) {
        return true;
      }

      const normalized = (descripcion || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase()
        .replace(/\s+/g, ' ')
        .trim();

      if (!normalized) return false;
      if (normalized.includes('ODONTOLOGIA (CE)')) return true;
      if (normalized.includes('ODONTOLOGIA') && normalized.includes('CE')) return true;

      return false;
    },

    removeDiagnostico(index) {
      this.diagnosticosList.splice(index, 1);
      // this.$store.dispatch('removeDiagnostico', index);
    },


    triggerFileInput() {
      this.$refs.fileInput.click();
    },


    async ejecutarInformeImagen() {
      let coberturasSubidas = this.requiresMsp
        ? localStorage.getItem("coberturasSubidas")
        : true;
     

      const confirmacionEjecucion = await this.$swal({
        title: '¿Estás seguro de ejectuar el informe de imagen?',
        text: 'No podrás deshacer esta acción.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar'
      });

      const files = this.stDocsMsps;
      let uploadError = null;
      let urlMspPaciente = null;
      let urlMspTitular1 = null;
      let urlMspTitular2 = null;
      let urlMspTitular3 = null;
      
      await Promise.all(
        Object.keys(files).map(async (key) => {
          const fileGroup = files[key];

          if(!fileGroup) return;

          const dataField = (key === 'mspPaciente')
            ? this.dataInforme?.urlMsp
            : key === 'mspTitular1'
              ? this.dataInforme?.urlMspTitular1
              : key === 'mspTitular2'
                ? this.dataInforme?.urlMspTitular2
                : key === 'mspTitular3'
                  ? this.dataInforme?.urlMspTitular3
                  : null;


          let dataFieldObj = null;

          try{
            dataFieldObj = JSON.parse(dataField);
          } catch (error) {
            dataFieldObj = { identificacion: '1111111111', urls: { "1": dataField } };
          }

          const objectFile = {
            identificacion: fileGroup.identificacion,
            urls: dataFieldObj?.urls || {},
          }
          
          
          if (fileGroup.newMsp !== null){

            if(fileGroup.newMsp === undefined) {
              await fileService.deleteFile(fileGroup.urlMsp);
              objectFile.urls["1"] = null;
            } else {
              const up1 = await fileService.upload('msp', fileGroup.newMsp, `${fileGroup.identificacion}`, fileGroup.urlMsp);
              if (!up1) {
                uploadError = `No se pudo subir el MSP de ${fileGroup.identificacion}.`;
              }
              objectFile.urls["1"] = up1;
            }

          }


          if (fileGroup.newMsp2 !== null){

            if(fileGroup.newMsp2 === undefined) {
              await fileService.deleteFile(fileGroup.urlMsp2);
              objectFile.urls["2"] = null;
            } else {
              const up2 = await fileService.upload('msp', fileGroup.newMsp2, `${fileGroup.identificacion}`, fileGroup.urlMsp2);
              if (!up2) {
                uploadError = `No se pudo subir el MSP (día 2) de ${fileGroup.identificacion}.`;
              }
              objectFile.urls["2"] = up2;
            }
          } 

          if(key === 'mspPaciente')
            urlMspPaciente = JSON.stringify(objectFile);

          if(key === 'mspTitular1')
            urlMspTitular1 = JSON.stringify(objectFile);

          if(key === 'mspTitular2')
            urlMspTitular2 = JSON.stringify(objectFile);

          if(key === 'mspTitular3')
            urlMspTitular3 = JSON.stringify(objectFile);

        })
      );

      if (uploadError) {
        await this.$swal({ icon: 'error', title: 'Error al subir MSP', text: uploadError });
        return;
      }

      const url_informe = await fileService.upload('informeImagen', this.archivoInformeMedico, 'informe');
      let urlImagenes = this.urlCarpetaImagenes;
      let urlImagenesDicom = this.urlCarpetaImagenesDicom;
      if (this.archivoImagenes !== null){

        if(this.archivoImagenes === undefined)
          await fileService.deleteFile(this.urlCarpetaImagenes);

        urlImagenes = (this.archivoImagenes === undefined)
          ? null
          : await fileService.upload('informeImagen', this.archivoImagenes, `imagenes`, this.urlCarpetaImagenes);
      } 

      // DICOM → debe venir un File .dcm para convertir a PNG
      if (this.archivoImagenDicom !== null) {
        if (this.archivoImagenDicom === undefined) {
          // marcar borrado
          await fileService.deleteFile(this.urlCarpetaImagenesDicom);
          urlImagenesDicom = null;
        } else {
          // subir DICOM --> backend devuelve .png en /informeImagenDicom/
          urlImagenesDicom = await fileService.upload(
            'informeImagenDicom',
            this.archivoImagenDicom,
            `imagenes`,
            this.urlCarpetaImagenesDicom
          );
        }
      } else {
        // Usuario no tocó el campo DICOM; si lo que hay guardado es PDF, mejor lo anulamos para no confundir
        const prev = (this.urlCarpetaImagenesDicom || '').toLowerCase();
        if (prev.endsWith('.pdf')) {
          urlImagenesDicom = null; // así no se re-guarda un PDF como “dicom”
        }
      }

      // const urlImagenes = (this.archivoImagenes)
      //   ? await fileService.upload('informeImagen', this.archivoImagenes, 'imagenes')
      //   : this.urlCarpetaImagenes;
      console.log("esta es la data imagen", this.dataImagen) 
      

      const informeImagenData = {
        idInforme           : this.dataInforme?.id,
        id_envio_imagen     : this.dataImagen.idImagenEnviada, // Asegúrate de que este es el nombre correcto del campo esperado por el backend
        informe_imagen      : this.informe,
        conclusion_imagen   : this.conclusion,
        imagenologo_id      : this.imagenologo,
        coberturasSubidas   : coberturasSubidas || false,
        url_msp             : urlMspPaciente,
        url_msp_titular1    : urlMspTitular1,
        url_msp_titular2    : urlMspTitular2,
        url_msp_titular3    : urlMspTitular3,
        url_informe         : url_informe,
        url_carpeta_imagenes: urlImagenes,
        url_carpeta_imagenes_dicom: urlImagenesDicom,
        diagnosticos: this.diagnosticosList,
      };

      if (!confirmacionEjecucion.isConfirmed) return;

      const responseEjecutar = this.dataInforme?.id
        ? await imagenesService.actualizarInforme(informeImagenData)
        : await imagenesService.crearInforme(informeImagenData);


      if (responseEjecutar.status !== 'Success') {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un error al enviar el informe de imagen.'
        });

        return;
      }

      this.$swal({
        icon: 'success',
        title: 'Éxito',
        text: 'El informe se creó con éxito..'
      }).then(() => this.$router.go(0));

      this.isVisible = false;
    },



    agregarDiagnostico() {
     
      const diagnosticoSelected = this.searchDiagnosticos.selected;

      if (!diagnosticoSelected) {
        this.$swal({
          title: 'Campos Incompletos',
          text: 'Por favor, seleccione un diagnóstico antes de agregar.',
          icon: 'warning',
          confirmButtonText: 'Ok'
        });
        return;
      }
      const newDiagnostico = {
        diagnostico: diagnosticoSelected.value,
        diagnosticotext: diagnosticoSelected.text
      };

      const exists = this.diagnosticosList.find(d =>
        d.diagnostico === newDiagnostico.diagnostico
      );

      if (exists) {
        this.$swal({
          title: 'Diagnostico repetido',
          text: 'Por favor, seleccione un diagnóstico diferente.',
          icon: 'warning',
          confirmButtonText: 'Ok'
        });
        return;
        
      }else{this.diagnosticosList.push(newDiagnostico);}

      this.searchDiagnosticos.selected = null;
      // this.$store.dispatch('addDiagnostico', nuevoDiagnostico);
    },


    onHidden() {
      this.isVisible = false;
      this.archivoInformeMedico = null;
      this.archivoImagenes = null;
      this.informe = null;
      this.conclusion = null;
      this.imagenologo = null;
      this.diagnosticosList = [];
      this.dataInforme = null;
      this.urlCarpetaImagenes = null;
      this.doctorEspecialidad = null;
      this.requiresMsp = true;

      this.$store.commit('resetFiles');
    }


  },

  computed: {
    ...mapState({
      stDocsMsps: state => state.docsMsps.files,
    }),

  },


  watch: {

    '$route.query.procesar':{
      handler(newValue) {
        this.loadData();
      }
    },


    isVisible: {
      deep: true,
      handler(newValue) {
        if( !newValue ) this.$router.push({ name: 'consultar-imagenes' })
      }
    },


    archivoImagenes : {
      deep: true,
      handler(newValue) {
        console.log('this.archivoImagenes', newValue);
      }
    }

  },

}
</script>
